import { RouteRecordRaw } from 'vue-router'
import { metaRequireAuth } from '@/router/meta-constants'
import HomePage from '@/views/home/index.vue'
import History from '@/views/history/index.vue'
import Scan from '@/views/scan/index.vue'
import ReportPage from '@/views/report/index.vue'
import Print from '@/views/print/index.vue'
import Sports from '@/views/sports/index.vue'
import Number from '@/views/number/number.vue'
import Loto from '@/views/loto/index.vue'
import LotoEvent from '@/views/loto/events.vue'
import LotoNumber from '@/views/loto/numbers.vue'
import LottoFixedDaily from '@/views/loto/daily-lotto/index.vue'
import LottoFixedDailyNumber from '@/views/loto/daily-lotto/number.vue'
import LottoInstantNumber from '@/views/loto/instant/number.vue'
import ChangePinPage from '@/views/change-pin/index.vue'
import AboutPage from '@/views/about/index.vue'
import ResultPage from '@/views/result/index.vue'

const authenticatedRoutes: Array<RouteRecordRaw> = [
    {
        path: '/',
        name: 'Home Page',
        meta: {
            ...metaRequireAuth,
            isHidenNatigation: true,
        },
        component: HomePage,
    },
    {
        path: '/history',
        name: 'History',
        meta: metaRequireAuth,
        component: History,
    },
    {
        path: '/scan',
        name: 'Scan',
        meta: metaRequireAuth,
        component: Scan,
    },
    {
        path: '/report-final',
        name: 'Report Final Page',
        component: ReportPage,
        meta: {
            ...metaRequireAuth,
            isFinal: true,
        },
    },
    {
        path: '/report',
        name: 'Report Page',
        component: ReportPage,
        meta: {
            ...metaRequireAuth,
            isFinal: false,
        },
    },
    {
        path: '/print',
        name: 'Print',
        meta: metaRequireAuth,
        component: Print,
    },
    {
        path: '/sports',
        name: 'Sports',
        meta: {
            ...metaRequireAuth,
            isHidenNatigation: true,
        },
        component: Sports,
    },
    {
        path: '/number',
        name: 'number',
        meta: {
            ...metaRequireAuth,
            isHidenNatigation: true,
        },
        component: Number,
    },
    {
        path: '/loto-590',
        name: 'loto590',
        meta: {
            ...metaRequireAuth,
        },
        component: Loto,
    },
    {
        path: '/loto-event',
        name: 'lotoEvent',
        meta: {
            ...metaRequireAuth,
        },
        component: LotoEvent,
    },
    {
        path: '/loto-numbers',
        name: 'lotoNumber',
        meta: {
            ...metaRequireAuth,
        },
        component: LotoNumber,
    },
    {
        path: '/lotto-fixed-daily-lotto',
        name: 'lottoFixedDaily',
        meta: {
            ...metaRequireAuth,
        },
        component: LottoFixedDaily,
    },
    {
        path: '/lotto-fixed-daily-lotto/number',
        name: 'lottoFixedDailyNumber',
        meta: {
            ...metaRequireAuth,
        },
        component: LottoFixedDailyNumber,
    },
    {
        path: '/instant-lotto/number',
        name: 'lottoInstant',
        meta: {
            ...metaRequireAuth,
        },
        component: LottoInstantNumber,
    },
    {
        path: '/abouts',
        name: 'AboutPage',
        meta: {
            ...metaRequireAuth,
            isShowMenu: true,
        },
        component: AboutPage,
    },
    {
        path: '/result',
        name: 'ResultPage',
        meta: {
            ...metaRequireAuth,
        },
        component: ResultPage,
    },
    {
        path: '/change-pin',
        name: 'ChangePinPage',
        meta: {
            ...metaRequireAuth,
        },
        component: ChangePinPage,
    },
]

export default authenticatedRoutes
